export class OTA_SpecialEquipPref {
    public equipType: string;
    public quantity: number;
}
